import React, { Component, Fragment } from 'react';
import { Col, Label, Input, FormGroup } from "reactstrap";
import { inject, observer } from 'mobx-react';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import { toJS } from 'mobx';

@inject("store")
@observer
export default class ListaServicosAcessorios extends Component {

    colunas;

    constructor(props) {
        super(props);

        this.dataStore = this.props.dataStore;
        this.modalStore = this.props.store.modalStoreCustom;
        this.showQtd = this.props.showQtd;

        this.colunas = [
            {
                dataField: "Servico",
                text: "Serviço",
                headerAlign: (column, colIndex) => 'left',
                align: () => { return "left" },
            }
        ];

        if (this.props.showQtd) {
            this.colunas = [
                ...this.colunas,
                {
                    dataField: "Codigo",
                    text: "Quantidade",
                    headerAlign: (column, colIndex) => 'left',
                    style: { maxWidth: "6rem" },
                    align: () => { return "left" },
                    formatter: (cell, row) => (
                        <FormGroup className="m-0" >
                            <Input 
                                type="number"
                                onChange={({ target }) => this.dataStore.changeQtd(row.ClassificacaoId, target.value)}
                            />
                        </FormGroup>
                    ),
                }
            ];
        }
    }

    getSelectRow = () => ({
        mode: 'checkbox',
        nonSelectable: this.dataStore.NonSelectableIds,
        onSelect: (row, isSelect, rowIndex, e) => this.dataStore.selecionaServicoAcessorio(isSelect, row.Codigo),
        hideSelectAll: true,
        headerColumnStyle: { textAlign: 'left' , paddingLeft: '20px' },
        selectColumnStyle: { paddingLeft: '20px', paddingRight: '20px' }
    });

    render() {
        const { SearchBar } = Search;
        const servicos = toJS(this.dataStore.servicosAcessorios.value);
 
        return (
            <Fragment>
                <Col xs={12} sm={12} md={12} lg={12} xl={12} className="">                    
                    <ToolkitProvider
                        keyField='ClassificacaoId'
                        data={[...servicos]}
                        columns={this.colunas}
                        search
                        bootstrap4
                    >
                    {props => (
                            <div>
                                <Col xs={10} sm={10} md={10} lg={10} xl={10} className="px-0">
                                    <Label className="mb-2 mr-3">Busca:</Label>
                                    <SearchBar 
                                        placeholder="Digite o serviço" 
                                        style={{ fontSize: '10px', fontStyle: ''}}
                                        { ...props.searchProps }
                                    />
                                </Col>
                                <Label className="my-2 mr-3">Serviços Acessórios</Label>
                                <div id="tableHeaderFixed" className="tabela-overflow-paginated border pt-1" style={{ height: '300px'}}>
                                    <BootstrapTable
                                        striped
                                        condensed
                                        hover
                                        bordered={false}
                                        classes="tabela tabela-layout mb-0"
                                        selectRow={this.showQtd ? undefined : this.getSelectRow()}
                                        noDataIndication="Serviços não encontrados ou já lançados!"
                                        { ...props.baseProps }                                                            
                                    />
                                </div>
                            </div>
                        )
                    }
                    </ToolkitProvider>
                </Col>
            </Fragment>
        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/simulacao-servicos/components/ListaServicosAcessorios.js